import {
  createStackHeaderNavigator,
  ModalCloseButton,
} from "@towersystems/roam-common-native";
import {
  ActionsRootParamList,
  AddGiftVoucherRootParamList,
} from "../../../../types";
import {
  CardStyleInterpolators,
  StackScreenProps,
} from "@react-navigation/stack";
import { AddGiftVoucherScreen } from "./AddGiftVoucherScreen";

const Stack = createStackHeaderNavigator<AddGiftVoucherRootParamList>();

export interface AddGiftVoucherRootScreenProps
  extends StackScreenProps<ActionsRootParamList, "AddGiftVoucherRootScreen"> {}

export const AddGiftVoucherRootScreen = ({}: AddGiftVoucherRootScreenProps) => {
  return (
    <Stack.Navigator
      screenOptions={{
        headerShown: true,
        title: ``,
        headerLeft: () => <ModalCloseButton type="Back" />,
        cardStyleInterpolator: CardStyleInterpolators.forHorizontalIOS,
      }}
    >
      <Stack.Screen
        name="AddGiftVoucherScreen"
        component={AddGiftVoucherScreen}
      />
    </Stack.Navigator>
  );
};
